
export default function TeamSection() {
  const steps = [
    {
      number: '1',
      title: 'Free Consultation',
      description: "We'll start with an initial discovery call to identify how we can best assist you."
    },
    {
      number: '2',
      title: 'Strategic Development',
      description: "Once we outline the scope of services needed, we'll draft a clear agreement and plan of action to ensure alignment."
    },
    {
      number: '3',
      title: 'Plan Implementation',
      description: "We'll provide a clear timeline of expectations and deliverables, schedule periodic check-ins, and check off tasks in a timely manner."
    },
    {
      number: '4',
      title: 'Final Delivery',
      description: "Upon completion, we'll provide full access and authority to all content and deliverables."
    }
  ];

  return (
    <section id="process" className="py-16 bg-white" aria-labelledby="process-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-medium tracking-wider text-gray-500 mb-3">
            WHAT YOU CAN EXPECT
          </p>
          <h2 id="process-heading" className="text-4xl font-light text-gray-900 mb-4">
            Let's Turn Your Ideas into <strong className="font-semibold">Measurable Success!</strong>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" role="list" aria-label="ProEditions process steps">
          {steps.map((step, index) => (
            <div key={index} className="relative" role="listitem">
              <div className="bg-gray-50 rounded-lg p-8 h-full hover:shadow-lg transition-shadow duration-300">
                <div 
                  className="flex items-center justify-center w-14 h-14 rounded-full bg-gray-900 text-white text-2xl font-light mb-6"
                  aria-label={`Step ${step.number}`}
                >
                  {step.number}
                </div>
                <h3 className="text-xl font-medium text-gray-900 mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-14 -right-4 w-8 h-0.5 bg-gray-300" aria-hidden="true"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
